type View = {
  "@id": string;
  "@type": string;
  first: string;
  last: string;
  next?: string;
  previous?: string;
};

type Mapping = {
  "@type": string;
  variable: string;
  property: string;
  required: boolean;
};

type Search = {
  "@type": string;
  template: string;
  variableRepresentation: string;
  mapping: Mapping[];
};

export type JsonLdCollection<T> = {
  "@id": string;
  "@type": string;
  totalItems: number;
  member: T[];
  view?: View;
  search?: Search;
};
